// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Yj8c","label":"SetPasswdForm_label__10m2y"};